import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { GetReportingToService } from 'app/shared/common/helper/get-reporting-to';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { ToastrService } from 'ngx-toastr';
import { SelectItem } from 'primeng/api';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { CommonValidation } from 'app/shared/common/common-validation';

@Component({
  selector: 'app-performance-review',
  templateUrl: './performance-review.component.html',
  styleUrls: ['./performance-review.component.scss'],
  animations: fuseAnimations
})
export class PerformanceReviewComponent implements OnInit {

  performanceReviewForm: FormGroup;
  reportingToOptions = [];
  deptOptions: SelectItem[];
  employeeList = [];
  profileId = '';
  optionList = [
    { label: 'Poor', value: 'Poor', rating: 1 },
    { label: 'Fair', value: 'Fair', rating: 2 },
    { label: 'Satisfactory', value: 'Satisfactory', rating: 3 },
    { label: 'Good', value: 'Good', rating: 4 },
    { label: 'Excellent', value: 'Excellent', rating: 5 }
  ];
  isEdit = false;
  roleList = [];
  totalRatings = 0;
  @ViewChild(FormGroupDirective, { static: false }) formGroupDirective: FormGroupDirective;
  jobKnowledge = 0;
  workQuality = 0;
  initiative = 0;
  communication = 0;
  dependability = 0;
  maxDate = new Date();
  reportingTo = '';
  empRole = '';
  filteredOptions: Observable<string[]>;
  myControl = new FormControl();
  selectedProfileId = '';
  reviewId = '';
  isReview = 'false';
  tenantId: any;
  reportingToId: any;

  constructor(
    private parseService: ParseService,
    private formBuilder: FormBuilder,
    private storageConfiguration: StorageConfiguration,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private router: Router,
    private queryInterface: QueryInterface,
    private getReportingToService: GetReportingToService,
    private commonValidation: CommonValidation,
    private route: ActivatedRoute
  ) {
    this.profileId = this.parseService.instance.User.current().get('profile').id;
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    this.performanceReviewForm = this.formBuilder.group({
      name: [''],
      employeeId: [''],
      jobTitle: ['', Validators.required],
      date: ['', Validators.required],
      department: ['', Validators.required],
      manager: ['', Validators.required],
      reviewStartDate: ['', Validators.required],
      reviewEndDate: ['', Validators.required],
      additionalComments: [''],
      goals: ['', Validators.required],
      jobKnowledge: ['', Validators.required],
      workQuality: ['', Validators.required],
      initiative: ['', Validators.required],
      communication: ['', Validators.required],
      dependability: ['', Validators.required],
      jobKnowledgeComments: [''],
      workQualityComments: [''],
      initiativeComments: [''],
      communicationComments: [''],
      dependabilityComments: [''],
      overallRatings: ['']
    });
  }

  ngOnInit() {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.getReportingTo();
    this.getDepartment();
    this.getRole();
    this.getEmployeeList();

    this.route.params.subscribe(params => {
      this.reviewId = params['id'];
      this.isReview = params['isReview'];
      if (this.reviewId != undefined) {
        this.isEdit = true;
        this.getReviewDetails();
      }
    });

  }

  async getReportingTo() {
    await this.getReportingToService.getReportingTo().then(res => {
      this.reportingToOptions = res;
    });
  }

  async getDepartment() {
    await this.getReportingToService.getDepartment().then(res => {
      this.deptOptions = res;
    });
  }

  async getRole() {
    let result = [];
    this.queryInterface.queryRole(this.parseService).then(results => {
      for (let i = 0; i < results.length; i++) {
        let jsonText = JSON.stringify(results[i]);
        let roleInfo = JSON.parse(jsonText);
        if (roleInfo.displayName) {
          result.push({ id: roleInfo.role.objectId, name: roleInfo.displayName });
          this.roleList = result;
        }
        else {
          result.push({ id: roleInfo.objectId, name: roleInfo.name });
          this.roleList = result;
        }
      }
    });
  }

  async getEmployeeList() {
    let profileInstance = this.parseService.instance.Object.extend('Profile');
    let query = new this.parseService.instance.Query(profileInstance);
    query.equalTo('isActive', true);
    query.equalTo('isLongLeave', false);
    query.limit(1000);
    query.include('location');
    query.include('role');
    query.include('department');
    query.include('reportingTo');
    query.ascending('firstName');
    query.equalTo('tenantId', this.tenantId);
    let profileList = await query.find();
    this.employeeList = [];
    let i = 0;
    for (const element of profileList) {
      i = i + 1;
      this.employeeList.push({
        name: element.get('firstName') + ' ' + element.get('lastName'),
        value: element.id
      });
    }
    this.getFilteredValue();
  }

  getFilteredValue() {
    if (this.employeeList.length > 0) {
      this.filteredOptions = this.myControl.valueChanges.pipe(
        startWith(''),
        map(skillSets => this._filter(skillSets))
      );
    }
  }

  private _filter(value: string): any[] {
    let userRole1 = JSON.stringify(this.employeeList);
    let userRole = JSON.parse(userRole1);
    const filterValue = value.toLowerCase();
    return userRole.filter(option => option.name
      .toString()
      .toLowerCase()
      .includes(filterValue)
    );
  }

  chooseResource(event) {
    var queryProfile = new this.parseService.instance.Object('Profile');
    queryProfile.id = event;
    this.reportingToId = queryProfile.get('reportingTo').id;
    this.selectedProfileId = event;
    this.performanceReviewForm.patchValue({
      employeeId: '',
      department: queryProfile.get('department').id,
      jobTitle: queryProfile.get('role').id,
      date: queryProfile.get('officialInfo').reportingDate,
      reviewStartDate: this.addMonths(new Date(), -6),
      reviewEndDate: new Date(),
      manager: this.reportingToId
    });
    this.reportingTo = queryProfile.get('reportingTo').id;
  }

  addMonths(date, months) {
    date.setMonth(date.getMonth() + months);
    return date;
  }

  calculateTotalRatings() {
    this.totalRatings = 0;
    this.totalRatings += this.jobKnowledge + this.workQuality + this.initiative + this.communication + this.dependability;
    let total = (this.totalRatings / 5).toFixed(1);
    this.performanceReviewForm.patchValue({
      overallRatings: total
    });
  }

  async submitPerformanceReview() {
    const errorArray = [];
    const controls = this.performanceReviewForm.controls;
    for (const value in controls) {
      if (controls[value].invalid) {
        errorArray.push(value);
      }
    }
    if (this.selectedProfileId == '') {
      errorArray.push('selectResource');
    }
    if (errorArray.length == 0) {
      if (this.performanceReviewForm.valid) {
        let values = this.performanceReviewForm.value;
        let performanceClass = this.parseService.instance.Object.extend('PerformanceReview');
        var performance = new performanceClass();

        let performanceDetails = [
          {
            type: 'Job Knowledge',
            rating: values.jobKnowledge,
            comments: values.jobKnowledgeComments,
            marks: this.jobKnowledge
          },
          {
            type: 'Work Quality',
            rating: values.workQuality,
            comments: values.workQualityComments,
            marks: this.workQuality
          },
          {
            type: 'Initiative',
            rating: values.initiative,
            comments: values.initiativeComments,
            marks: this.initiative
          },
          {
            type: 'Communication',
            rating: values.communication,
            comments: values.communicationComments,
            marks: this.communication
          },
          {
            type: 'Dependability',
            rating: values.dependability,
            comments: values.dependabilityComments,
            marks: this.dependability
          }
        ]

        performance.set('profileId', { __type: 'Pointer', className: 'Profile', objectId: this.selectedProfileId });
        performance.set('manager', { __type: 'Pointer', className: 'Profile', objectId: values.manager });
        performance.set('department', { __type: 'Pointer', className: 'Department', objectId: values.department });
        performance.set('jobTitle', { __type: 'Pointer', className: '_Role', objectId: values.jobTitle });
        performance.set('reportingDate', new Date(values.date));
        performance.set('employeeId', values.employeeId);
        performance.set('reviewStartDate', new Date(values.reviewStartDate));
        performance.set('reviewEndDate', new Date(values.reviewEndDate));

        performance.set('performanceDetails', performanceDetails);

        performance.set('jobKnowledge', values.jobKnowledge);
        performance.set('workQuality', values.workQuality);
        performance.set('initiative', values.initiative);
        performance.set('communication', values.communication);
        performance.set('dependability', values.dependability);

        performance.set('overallRatings', this.totalRatings);
        performance.set('additionalComments', values.additionalComments);
        performance.set('goals', values.goals);
        performance.set('isActive', true);
        performance.set('reportingTo', { __type: 'Pointer', className: 'Profile', objectId: this.reportingTo });
        performance.set('createdBy', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
        var queryProfile = new this.parseService.instance.Object('Profile');
        queryProfile.id = values.name;

        performance.set('firstName', queryProfile.get('firstName'));
        performance.set('lastName', queryProfile.get('lastName'));
        performance.set('email', queryProfile.get('email'));
        performance.set('tenantId', this.tenantId);
        let data = await performance.save();
        this.toastr.success('Saved successfully');
        setTimeout(() => this.formGroupDirective.resetForm(), 200);
        this.router.navigate(['/performance-review']);
      }
      else {
        this.toastr.warning('Please enter the required fields');
      }
    }
    else {
      const validationArray = this.commonValidation.getValidation(errorArray);
      let toastvalue = '<h4>Please Check the Followings </h4> <ul>';
      validationArray.forEach(element => {
        toastvalue += '<li>' + element + ' </li>';
      });
      toastvalue += '</ul>';
      this.toastr.warning(toastvalue);
    }
  }

  async getReviewDetails() {
    const reviewInstance = this.parseService.instance.Object.extend('PerformanceReview');
    const query = new this.parseService.instance.Query(reviewInstance);
    query.equalTo('objectId', this.reviewId);
    query.include('jobTitle');
    query.include('department');
    query.include('manager');
    query.include('profileId');
    query.equalTo('tenantId', this.tenantId);
    const results = await query.find();
    let data = results[0];
    let performanceDetails = data.get('performanceDetails');
    let jobKnowledgeComments = performanceDetails.find(x => x.type == 'Job Knowledge');
    let workQualityComments = performanceDetails.find(x => x.type == 'Work Quality');
    let initiativeComments = performanceDetails.find(x => x.type == 'Initiative');
    let communicationComments = performanceDetails.find(x => x.type == 'Communication');
    let dependabilityComments = performanceDetails.find(x => x.type == 'Dependability');

    let userName = data.get('profileId').get('firstName') + ' ' + data.get('profileId').get('lastName');
    this.myControl.setValue(userName);
    this.selectedProfileId = data.get('profileId').id;

    this.totalRatings = data.get('overallRatings');
    this.jobKnowledge = jobKnowledgeComments.marks;
    this.workQuality = workQualityComments.marks;
    this.initiative = initiativeComments.marks;
    this.communication = communicationComments.marks;
    this.dependability = dependabilityComments.marks;

    this.performanceReviewForm.patchValue({
      jobTitle: data.get('jobTitle').id,
      department: data.get('department').id,
      manager: data.get('manager').id,
      date: data.get('reportingDate'),
      employeeId: data.get('employeeId'),
      reviewStartDate: data.get('reviewStartDate'),
      reviewEndDate: data.get('reviewEndDate'),

      jobKnowledge: data.get('jobKnowledge'),
      workQuality: data.get('workQuality'),
      initiative: data.get('initiative'),
      communication: data.get('communication'),
      dependability: data.get('dependability'),
      jobKnowledgeComments: jobKnowledgeComments.comments,
      workQualityComments: workQualityComments.comments,
      initiativeComments: initiativeComments.comments,
      communicationComments: communicationComments.comments,
      dependabilityComments: dependabilityComments.comments,
      overallRatings: (data.get('overallRatings') / 5),
      additionalComments: data.get('additionalComments'),
      goals: data.get('goals'),
    });
  }

  returnRatings(event) {
    let result = this.optionList.find(x => x.value == event);
    return result.rating;
  }

  async updateReviewDetails() {
    const errorArray = [];
    const controls = this.performanceReviewForm.controls;
    for (const value in controls) {
      if (controls[value].invalid) {
        errorArray.push(value);
      }
    }
    if (this.selectedProfileId == '') {
      errorArray.push('selectResource');
    }
    if (errorArray.length == 0) {
      if (this.performanceReviewForm.valid) {
        let reviewInstance = this.parseService.instance.Object.extend('PerformanceReview');
        let query = new this.parseService.instance.Query(reviewInstance);
        query.equalTo('objectId', this.reviewId);
        let results = await query.find();
        let performance = results[0];
        let values = this.performanceReviewForm.value;

        let performanceDetails = [
          {
            type: 'Job Knowledge',
            rating: values.jobKnowledge,
            comments: values.jobKnowledgeComments,
            marks: this.jobKnowledge
          },
          {
            type: 'Work Quality',
            rating: values.workQuality,
            comments: values.workQualityComments,
            marks: this.workQuality
          },
          {
            type: 'Initiative',
            rating: values.initiative,
            comments: values.initiativeComments,
            marks: this.initiative
          },
          {
            type: 'Communication',
            rating: values.communication,
            comments: values.communicationComments,
            marks: this.communication
          },
          {
            type: 'Dependability',
            rating: values.dependability,
            comments: values.dependabilityComments,
            marks: this.dependability
          }
        ]

        performance.set('manager', { __type: 'Pointer', className: 'Profile', objectId: values.manager });
        performance.set('department', { __type: 'Pointer', className: 'Department', objectId: values.department });
        performance.set('jobTitle', { __type: 'Pointer', className: '_Role', objectId: values.jobTitle });
        performance.set('reportingDate', new Date(values.date));
        performance.set('employeeId', values.employeeId);
        performance.set('reviewStartDate', new Date(values.reviewStartDate));
        performance.set('reviewEndDate', new Date(values.reviewEndDate));
        performance.set('performanceDetails', performanceDetails);
        performance.set('jobKnowledge', values.jobKnowledge);
        performance.set('workQuality', values.workQuality);
        performance.set('initiative', values.initiative);
        performance.set('communication', values.communication);
        performance.set('dependability', values.dependability);
        performance.set('overallRatings', this.totalRatings);
        performance.set('additionalComments', values.additionalComments);
        performance.set('goals', values.goals);

        let data = await performance.save();
        this.toastr.success('Updated successfully');
        this.router.navigate(['/performance-review']);

      }
      else {
        this.toastr.warning('Please enter the required fields');
      }
    }
    else {
      const validationArray = this.commonValidation.getValidation(errorArray);
      let toastvalue = '<h4>Please Check the Followings </h4> <ul>';
      validationArray.forEach(element => {
        toastvalue += '<li>' + element + ' </li>';
      });
      toastvalue += '</ul>';
      this.toastr.warning(toastvalue);
    }

  }

  backlocation() {
    this.router.navigate(['performance-review']);
  }

  jobKnowledgeRating(event) {
    this.jobKnowledge = event.rating;
    this.calculateTotalRatings();
  }

  workQualityRating(event) {
    this.workQuality = event.rating;
    this.calculateTotalRatings();
  }

  initiativeRating(event) {
    this.initiative = event.rating;
    this.calculateTotalRatings();
  }

  communicationRating(event) {
    this.communication = event.rating;
    this.calculateTotalRatings();
  }

  dependabilityRating(event) {
    this.dependability = event.rating;
    this.calculateTotalRatings();
  }

}
